// eslint-disable-next-line react/prop-types
function UserNotFound({ userFound }) {
  if (userFound === false) {
    return (
      <div style={{ padding: '24px' }}>
        <br />
        <h2 style={{ fontWeight: 'bold', letterSpacing: '0.8px', color: '#FB2961' }}>User not found.</h2>
      </div>
    );
  }
  return null;
}

export default UserNotFound;
